import { useEffect, useState } from 'react'
import { Provider } from 'react-redux'
import { PersistGate } from 'redux-persist/integration/react'
import LocalCache from '../../backend/LocalCache'
import { persistor, store } from '../../store/Store'
import logger from '../../core/logger/Logger'
import Helper from '../../helpers/Helper'
import DebugLogger from '../../core/logger/DebugLogService'
import ThemeInitializer from './ThemeInitializer'

export default function StoreInitializer() {
    const [ready, setReady] = useState(false)

    useEffect(() => {
        console.log('running intializer')
        LocalCache.init()
        if (Helper.isDev()) logger.register(DebugLogger)
        setReady(true)
        console.log('intializer ready')

        const userTyped = window.location.pathname.substring(1)

        if (userTyped && userTyped !== '') {
            LocalCache.set('lastEnteredRoute', userTyped)
            console.log('Captured URL on boot:', userTyped)
        }
    }, [])

    return (
        <Provider store={store}>
            <PersistGate persistor={persistor}>
                {ready && <ThemeInitializer />}
            </PersistGate>
        </Provider>
    )
}
